import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import configureStore from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={configureStore()}>
      <App />
    </Provider>
  </React.StrictMode>
);

const market = () => {
const href = window.location.href
  if (href.match(`\.sas\.se`)) {
    return href.match(`\.test`) ? "https://travelpass.test.sas.se" : "https://travelpass.sas.se"
} else if (href.match(`\.sas\.no`)) {
  return href.match(`\.test`) ? "https://travelpass.test.sas.no" : "https://travelpass.sas.no"
} else if (href.match(`\.sas\.dk`)) {
  return href.match(`\.test`) ? "https://travelpass.test.sas.dk" : "https://travelpass.sas.dk"
} else if (href.match(`\.sas\.fi`)) {
  return href.match(`\.test`) ? "https://travelpass.test.flysas.com" : "https://travelpass.flysas.com"
} else {
  return  href.match(`\.test`) ||  href.match(`\.local`) ? "https://travelpass.test.flysas.com" : "https://travelpass.test.flysas.com"
}

}
const loadTravelpassScript = (callback) => {
  const existingScript = document.getElementById('travelpassScript');
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = `${market()}/travelpass/dist/sales/sales-element-injector.js`;
    script.id = 'travelpassScript';
    document.body.appendChild(script);
    script.onload = () => { 
      if (callback) callback();
    };
  }
  if (existingScript && callback) callback();
};
loadTravelpassScript();
window.dispatchEvent(new CustomEvent("appLoaded"))
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

